import { useDispatch, useSelector } from 'react-redux'

import Spinner from '@/components/Spinner'
import { removePromoCode } from '@/reducers/cart/asyncActions'
import { translate } from '@/utils/translations'

const BUTTON_STYLES = [
  'accordion__remove-button',
  'link--branded',
  'styled-as-link',
  'u-weight--medium',
  'vst-btn--transparent'
].join(' ')

const RemoveButton = () => {
  const dispatch = useDispatch()
  const isUpdating = useSelector(state => state.cart.promoCode.isUpdating)
  const handleRemove = () => dispatch(removePromoCode())

  return (
    <Choose>
      <When condition={isUpdating}>
        <button className={BUTTON_STYLES}>
          <Spinner styles='sk-spinner-three-bounce ocean-theme' />
        </button>
      </When>
      <Otherwise>
        <button
          aria-label={translate('promo_code.remove')}
          className={BUTTON_STYLES}
          onClick={handleRemove}
        >
          {translate('carts.remove_from_cart')}
        </button>
      </Otherwise>
    </Choose>
  )
}

export default RemoveButton
